/** @jsxImportSource @emotion/react */
import { mono } from '@components/systems/backoffice/backoffice.tokens'

import React from 'react'
import { View } from './View'

interface PropsType {
	className?: string
	style?: React.CSSProperties
}

/** 헤어라인 — 모든 구분선은 `line` 1px(DESIGN_SYSTEM §2) */
export const Divider = (props: PropsType) => {
	return (
		<View
			css={[
				{
					marginTop: '1rem',
					marginBottom: '0.5rem',
					borderTop: `1px solid ${mono.line}`,
				},
				{ ...props.style },
			]}
			className={`dividerComponent ${props.className || ''}`}
		/>
	)
}
